import {useEffect} from "react";
import {connect} from "react-redux";
import {RouteComponentProps, withRouter} from "react-router";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import {css} from "@emotion/react";
import {map} from "lodash";
import {bindActionCreators, Dispatch} from "redux";
import {usePrevious} from "@web2/react_utils";

import {dropAllTtlAndRemoveInvalid, IAlert, removeAlert} from "./add_remove_alert_action";
import {Alert} from "./Alert";
import {IAlertsStoreElement} from "./alerts_reducer";

interface IStateProps {
    alerts: IAlert[];
}
interface IActionsProps {
    removeAlert: typeof removeAlert;
    dropAllTtlAndRemoveInvalid: typeof dropAllTtlAndRemoveInvalid;
}
interface IOwnProps extends RouteComponentProps<{}> {}

interface IProps extends IOwnProps, IStateProps, IActionsProps {}

const AlertsC = (props: IProps) => {
    const prevLocationKey = usePrevious(props.location.key, null, [props.location.key]);
    useEffect(() => {
        if (prevLocationKey !== props.location.key) {
            props.dropAllTtlAndRemoveInvalid();
        }
    }, [props.location.key]);

    useEffect(() => {
        return () => {
            props.dropAllTtlAndRemoveInvalid();
        };
    }, []);

    const alerts = map(props.alerts, (alert: IAlert) => (
        <CSSTransition key={alert.id} classNames={"slide-from-right"} timeout={5000} appear enter exit>
            <Alert {...alert} removeAlert={props.removeAlert} />
        </CSSTransition>
    ));

    return (
        <div css={alertsHolder}>
            <TransitionGroup>{alerts}</TransitionGroup>
        </div>
    );
};

function mapStateToProps(store: IAlertsStoreElement): IStateProps {
    return {
        alerts: store.alerts
    };
}

function mapActionsToProps(dispatch: Dispatch): IActionsProps {
    return bindActionCreators(
        {
            removeAlert,
            dropAllTtlAndRemoveInvalid
        },
        dispatch
    );
}

const AlertsConnected = connect<IStateProps, IActionsProps, IOwnProps, IAlertsStoreElement>(mapStateToProps, mapActionsToProps)(AlertsC);
export const Alerts = withRouter<IOwnProps, typeof AlertsConnected>(AlertsConnected);

const alertsHolder = css`
    position: fixed;
    right: 20px;
    top: 70px;
    z-index: 1000000001;
`;
